// @flow

import { createSelector } from 'reselect/lib';
import { getConfig }      from '../config';

// -----------------------------------------------------------------------------------------------------------------
// Base module state selector
// -----------------------------------------------------------------------------------------------------------------

const selectModuleState = (state) => state.get(getConfig().moduleStatePath);

// -----------------------------------------------------------------------------------------------------------------
// isPersonalised selector
// -----------------------------------------------------------------------------------------------------------------


export const selectIsPersonalised = createSelector(
  selectModuleState,
  (moduleState) => moduleState.get('isPersonalised'),
);

export const selectHideIsPersonalisedMessage = createSelector(
  selectModuleState,
  (moduleState) => moduleState.get('hideIsPersonalisedMessage'),
);


export const selectDisplayPersonalisedDataClearedMessage = createSelector(
  selectModuleState,
  (moduleState) => moduleState.get('displayPersonalisedDataClearedMessage'),
);



// WEBPACK FOOTER //
// ./src/modules/personalContent/store/selectors.js